module.exports = __webpack_public_path__ + "static/audio/momenta_fr.e5a3880.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/narration/audio/fr/momenta_fr.mp3
// module id = diN2
// module chunks = 0